var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row mt-4" }, [
    _c("div", { staticClass: "col-md-6 border-right mb-3" }, [
      _c("h5", [_vm._v("Perfiles Disponibles")]),
      _c(
        "div",
        { staticClass: "d-flex align-items-center justify-content-end" },
        [
          _c("b-form-input", {
            staticClass: "d-inline-block mr-1",
            attrs: {
              placeholder: "Filtrar...",
              "data-cy": "search-vacant-profile"
            },
            model: {
              value: _vm.searchInVacantProfiles,
              callback: function($$v) {
                _vm.searchInVacantProfiles = $$v
              },
              expression: "searchInVacantProfiles"
            }
          })
        ],
        1
      )
    ]),
    _c("div", { staticClass: "col-md-6 border-right mb-3" }, [
      _c("h5", [_vm._v("Perfiles Asignados")]),
      _c(
        "div",
        { staticClass: "d-flex align-items-center justify-content-end" },
        [
          _c("b-form-input", {
            staticClass: "d-inline-block mr-1",
            attrs: {
              placeholder: "Filtrar...",
              "data-cy": "search-asigned-profile"
            },
            model: {
              value: _vm.searchInAsignedProfiles,
              callback: function($$v) {
                _vm.searchInAsignedProfiles = $$v
              },
              expression: "searchInAsignedProfiles"
            }
          })
        ],
        1
      )
    ]),
    _c(
      "div",
      { staticClass: "col-md-6 border-right" },
      [
        _c(
          "vs-list",
          { staticClass: "box-users" },
          [
            _vm._l(_vm.filteredAvailableProfiles, function(role) {
              return _c(
                "div",
                { key: role.idPerfil },
                [
                  _c(
                    "vs-list-item",
                    {
                      directives: [
                        {
                          name: "tooltip",
                          rawName: "v-tooltip",
                          value: role.descripcion,
                          expression: "role.descripcion"
                        }
                      ],
                      attrs: { title: role.nombre }
                    },
                    [
                      !_vm.userProfiles[role.idPerfil]
                        ? _c(
                            "vs-button",
                            {
                              attrs: {
                                color: "warning",
                                size: "small",
                                type: "border",
                                "data-cy": "add-permission"
                              },
                              on: {
                                "~click": function($event) {
                                  return _vm.addProfile(role)
                                }
                              }
                            },
                            [_vm._v(" Agregar ")]
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            }),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.loading,
                    expression: "loading"
                  }
                ]
              },
              [
                _c("b-skeleton", {
                  attrs: { animation: "fade", width: "70%" }
                }),
                _c("b-skeleton", {
                  attrs: { animation: "fade", width: "80%" }
                }),
                _c("b-skeleton", {
                  attrs: { animation: "fade", width: "60%" }
                }),
                _c("b-skeleton", {
                  attrs: { animation: "fade", width: "85%" }
                }),
                _c("b-skeleton", { attrs: { animation: "fade", width: "70%" } })
              ],
              1
            )
          ],
          2
        )
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "col-md-6" },
      [
        _c(
          "vs-list",
          { staticClass: "box-users" },
          [
            _vm._l(_vm.filteredUserProfiles, function(role) {
              return _c(
                "div",
                {
                  key: role.idPerfil,
                  attrs: { "data-cy": "remove-permission" }
                },
                [
                  _c(
                    "vs-list-item",
                    {
                      directives: [
                        {
                          name: "tooltip",
                          rawName: "v-tooltip",
                          value: role.descripcion,
                          expression: "role.descripcion"
                        }
                      ],
                      attrs: { title: role.nombre }
                    },
                    [
                      _c("vs-button", {
                        attrs: {
                          color: "danger",
                          size: "small",
                          type: "border",
                          icon: "highlight_off",
                          "data-cy": "remove-permission"
                        },
                        on: {
                          "~click": function($event) {
                            return _vm.removeProfile(role)
                          }
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            }),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.loading,
                    expression: "loading"
                  }
                ]
              },
              [
                _c("b-skeleton", {
                  attrs: { animation: "fade", width: "70%" }
                }),
                _c("b-skeleton", {
                  attrs: { animation: "fade", width: "80%" }
                }),
                _c("b-skeleton", {
                  attrs: { animation: "fade", width: "60%" }
                }),
                _c("b-skeleton", {
                  attrs: { animation: "fade", width: "85%" }
                }),
                _c("b-skeleton", { attrs: { animation: "fade", width: "70%" } })
              ],
              1
            )
          ],
          2
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }